import Dropdowns from "../../../../_src/js/modules/dropdowns";
import Add2CartControls from "../../../../_src/js/modules/add2cart_controls.js"
import funcsCatalog from  "../../../../_src/js/functions/funcsCatalog.js"

class CatalogCats{
    constructor(){

    }

    bind(){
        try{

            // Функции для каталога
            funcsCatalog.init();

            if(typeof window.dropdowns === 'undefined'){
                window.dropdowns = new Dropdowns();
            }

            if(typeof window.cartControls === 'undefined'){
                window.cartControls = new Add2CartControls();
                window.cartControls.bindHandlers();
            }
            
            const $textBlock = $('.catalog-screen__text');
            let maxHeight = '3em';
            if($('body').width() < 778){
                maxHeight = "3em";
            }
            $textBlock.css("maxHeight", maxHeight);
        
            if ($textBlock.length) {
                if ($textBlock[0].scrollHeight > $textBlock.innerHeight()) {
                    var $toggleButton = $('<div class="read-all-button">Читать полностью</div>'); // Создаем кнопку через JS
                    $toggleButton.insertAfter($textBlock); // Добавляем кнопку после блока с текстом
                    $toggleButton.fadeIn(); // Показываем кнопку с эффектом fade-in
        
                    $toggleButton.on('click', function() {
                        $textBlock.toggleClass('expand');
                        if ($textBlock.hasClass('expand')) {
                            // анмация разворота блока
                            $textBlock.animate({
                                maxHeight: "2000px"
                            }, 100, function() {});
                            $toggleButton.text('Свернуть');
                        } else {
                            // анмация закрытие блока
                            $textBlock.animate({
                                maxHeight: maxHeight
                            }, 100, function() {});
        
                            $toggleButton.text('Читать полностью');
                        }
                    });
                }
            }

            // -------------------------------
            // Раскрытие тегов
            // -------------------------------
            const $catalogItemMoreBtn = $('.catalog-screen__item_type_more');

            if($(body).attr('data-ctx') == 'krovelnyjstroymarket'){
                if ($catalogItemMoreBtn.length) {
                    $catalogItemMoreBtn.on('click', function() {
                        $(this).parent().add($catalogItemMoreBtn).toggleClass('active');
                    });
                }
            }else{
                if ($catalogItemMoreBtn.length) {
                    $catalogItemMoreBtn.on('click', function() {
                        $(this).parent().add($catalogItemMoreBtn).toggleClass('active');
                    });
                }
            }
            
            $('.catalog-screen__items').each(function(){
                // Корректировка отображения меню на пк если элементов в списке категорий 5 то скрываем кнопку показать еще
                if($(this).children('.catalog-screen__item').length == 6){
                    $(this).children('.catalog-screen__item').eq(4).css("display", "block")
                    $(this).children('.catalog-screen__item_type_more').css('display', 'none')
                }
            });

            // -------------------------------
            // Раскрытие панелек с фильтрами на странице каталога / категории
            // -------------------------------
            let $filterBtn = $('.catalog__filter');
            if (window.innerWidth >= 1200) {
                // Если мы на компах, то раскрываем фильтры прямо при загрузке страницы.
                $('.filter-item__top').click();
            } else {
                let needExpandFilters = 1;
                // На телефонах надо делать иначе, в противном случае будет баг в фильтре с ценой (фильтр будет отображаться не полностью)
                $filterBtn.on('dropdown-toggle', function() {
                    if (needExpandFilters) {
                        $('.filter-item__top').click();
                        needExpandFilters = 0;
                    }
                });
            }

            // --------------------------------
            // Раскрытие / скрытие фильтров
            // --------------------------------
            $filterBtn.on('dropdown-close dropdown-toggle', function(e) {
                const $body = $('body');

                if ($(this).hasClass('active')) {
                    $body.addClass('filters-expanded');
                } else {
                    $body.removeClass('filters-expanded');
                }
            });

        }catch(t){
            console.error('Module catalog-cats failed:');
            console.error(t);
        }
    }

}

class CatalogCats_krovelnyjstroymarket extends CatalogCats{
    constructor(){
        super();
    }
    bind(){
        super.bind();
        try{
            // -------------------------------------------
            // Подсказка в чекбоксах в фильтрах
            // -------------------------------------------
            // Они есть только на кровле
            (async function(){
                if ($('.catalog__filter').length) {
                    //pageType = PAGE_TYPE_CATALOG;
                    const {TipsCatalog} = await import(/* webpackChunkName: "dynamics_1" */  "../../../../_src/js/modules/tips");
                    new TipsCatalog(".filter-item", ".filter-item__option");
                    //tips.run();
                } else {
                    return;
                }
            })();

            //Всплывашка в каталоге у первого товара на кровле
            (async function(){
                if(!document.querySelector('.product-card_catalog .tooltip'))return;
                const {PvaTooltip} = await import(/* webpackChunkName: "dynamics_1" */  "../../../../_src/js/modules/pvaTooltip");
                const catTooltip = new PvaTooltip('.product-card_catalog .tooltip');
                catTooltip.bind();
            })();

        }catch(t){
            console.error('Module catalog-cats failed:');
            console.error(t);
        }
    }
}

export {
    CatalogCats,
    CatalogCats_krovelnyjstroymarket
};